import { ConfigProvider } from "antd";
import Layout, { Content } from "antd/es/layout/layout";
import React from "react";
import hu_HU from 'antd/locale/hu_HU';
import { CMSSider } from "../../components/cms/sider/cms-sider";
import { Navigate, Outlet, useLoaderData } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setMe } from "../../redux/reducer/session.reducer";
import { clearAlertMessage, showAlertMessage } from "../../redux/reducer/alert-message.reducer";
import { AxiosResponse } from "axios";
import { GetMeSuccessResponse } from "../../features/users/types/api/get-me-success-response";
import { CMSHeader } from "../../components/cms/header/cms.header";
import './cms-layout.css';
import { RootState } from "../../redux/store";

export const CMSLayout = () => {
    const loaderData: any = useLoaderData();
    const dispatch = useDispatch();
    const needWideningForWorkInstructions = useSelector((state: RootState) => state.antdLayoutInfo.needWideningForWorkInstructions);

    if(loaderData?.getUserResponse?.status === 200) {
        const res: AxiosResponse<GetMeSuccessResponse> = loaderData.getUserResponse;
        dispatch(setMe({ user: res.data.user }));
    } else {

        dispatch(clearAlertMessage());
        dispatch(showAlertMessage({
            alertMessageText: 'Hiba történt a felhasználó azonosítása közben, kérjük jelentkezzen be.',
            alertMessageType: 'error'
        }));
        return <Navigate to='/cms/login' />;

    }

    let layoutStyle: React.CSSProperties | undefined = undefined;

    if (needWideningForWorkInstructions) layoutStyle = { minWidth: '1500px' };

    return (
        <ConfigProvider locale={hu_HU}>
            <Layout className='cms-layout' style={layoutStyle}>

                <CMSHeader />
                
                <Layout>
                    <CMSSider />

                    <Content className="main-content">
                        <Outlet />
                    </Content>
                </Layout>

            </Layout>
        </ConfigProvider>
    );
};